import React from 'react'
import PropTypes from 'prop-types'
import style from './RadioList.less'
import classNames from 'classnames'

export const RADIO_LIST_TYPE = {
  default: 'default',
  buttonList: 'buttonList',
}

const getMainClass = (type) => {
  const returnClass = [style.main]
  if (type == RADIO_LIST_TYPE.buttonList) {
    returnClass.push(style.buttonList)
  }
  return classNames(...returnClass)
}

const getListItemClass = (isActive, disabled) => {
  const returnClass = [style.listItem]
  if (isActive) {
    returnClass.push(style.listItemActive)
  }
  if (disabled) {
    returnClass.push(style.listItemDisabled)
  }
  return classNames(...returnClass)
}

const RadioList = (props) => (
  <div className={getMainClass(props.type)}>
  {props.title && <span className={style.title}>{props.title}</span>}
    <ul>
    {props.radioOptions && props.radioOptions.map((radioOption, index) => {
      const liProps = {
        key: index,
      }
      const isActive = (index == props.selected)
      if (isActive) {
        liProps['data-test'] = 'radioListActive'
      }
      return (
        <li
          {...liProps}
          className={getListItemClass(isActive, radioOption.disabled)}
          onClick={() => props.onChange(index)}
        >
          <div className={style.inputWrapper}>
            <input
              type="radio"
              name={props.id}
              id={`${props.id}-${index}`}
              value={radioOption.title}
              checked={(index == props.selected)}
              readOnly
            />
            <div className={style.check} />
            <label htmlFor={`${props.id}-${index}`}>
              {radioOption.title}
            </label>
            {radioOption.suffix &&
              <span className={style.suffix}>{radioOption.suffix}</span>
            }
            {radioOption.disabled &&
              <span className={style.suffix}>N/A</span>
            }
          </div>
          {radioOption.information && index == props.selected &&
            <span
              className={style.information}
              key={index}
              dangerouslySetInnerHTML={{ __html: radioOption.information }}
            ></span>
          }
        </li>
      )
    }
    )}
    </ul>
  </div>
)


RadioList.defaultProps = {
  selected: 0,
  type: RADIO_LIST_TYPE.default,
}

RadioList.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  selected: PropTypes.number,
  id: PropTypes.string,
  radioOptions: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    suffix: PropTypes.object,
    information: PropTypes.array,
    disabled: PropTypes.bool,
  })).isRequired,
  onChange: PropTypes.func,
}

export default RadioList
